var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.779,
    height: 35,
    viewBox: "0 0 30.779 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-38.6 -2.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.206,225.738v-9.856a1.26,1.26,0,0,1,1.33-1.353q7.758-.009,15.51,0a1.274,1.274,0,0,1,1.342,1.347V235.67a1.257,1.257,0,0,1-1.283,1.342c-.071.006-.147.006-.218.006H253.706a1.393,1.393,0,0,1-1.053-.294,1.339,1.339,0,0,1-.453-1.018Q252.209,230.728,252.206,225.738Zm3.9.053v6.973c0,.377,0,.377.382.377H266.1c.382,0,.382,0,.382-.377V218.813c0-.377,0-.382-.371-.382h-9.638c-.365,0-.365,0-.365.382Z",
    transform: "translate(-201.014 -199.153)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.608,25.06c0,3.886-.012,7.765.012,11.651A1.1,1.1,0,0,1,47.431,37.9c-.677-.012-1.354.012-2.031-.047a.962.962,0,0,1-.865-1V13.332c0-.43,0-.43-.43-.43H39.789A1.053,1.053,0,0,1,38.6,11.7V9.912a1.014,1.014,0,0,1,1.083-1.083c1.5,0,3-.006,4.5.006.283,0,.353-.088.353-.359-.012-1.472-.006-2.95-.006-4.421A1.026,1.026,0,0,1,45.682,2.9H47.5a.992.992,0,0,1,1.113,1.124V8.363c0,.471,0,.471.459.471q9.6,0,19.2-.006a.984.984,0,0,1,.948.483,1.241,1.241,0,0,1,.147.542c.018.665.012,1.336.006,2.008A1.012,1.012,0,0,1,68.36,12.9c-.1.006-.2,0-.3,0H49.044c-.442,0-.442,0-.442.43Q48.611,19.187,48.608,25.06Z",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo_black.796e0baa090ae0936e9d29b71207fb0e.svg";
export { ForwardRef as ReactComponent };